import React, { useEffect } from "react";
import { Routes, Route, Link, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./App.css";
import TagManager from 'react-gtm-module';

import ArenasList from "./components/arenas-list.component";
import Arena from "./components/arena.component";
import Place from "./components/place.component";
import Contact from "./components/contact.component";
import Sponsorship from "./components/sponsorship.component";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

// Configuração do GTM
const tagManagerArgs = {
  gtmId: 'GTM-KM8XSBBN',
  dataLayer: {
    appName: 'Replay Pro'
  }
};

// Inicializa o GTM apenas no lado do cliente
if (typeof window !== 'undefined') {
  TagManager.initialize(tagManagerArgs);
}

const App = () => {
  const location = useLocation();

  const getPageTitle = (pathname) => {
    const pathSegments = pathname.split('/').filter(Boolean);

    if (pathSegments.length >= 4) {
      const [, , name, place] = pathSegments;
      return `Replay Pro - ${decodeURIComponent(name)} - ${decodeURIComponent(place)}`;
    }

    if (pathSegments.length >= 3) {
      const [, , name] = pathSegments;
      return `Replay Pro - ${decodeURIComponent(name)}`;
    }

    return 'Replay Pro';
  };

  // Efeito para rastrear mudanças de rota
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const pageTitle = getPageTitle(location.pathname);
      document.title = pageTitle;

      // Configuração do dataLayer para GA4 via GTM
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'page_view', // Evento padrão do GA4
        page_path: location.pathname + location.search,
        page_title: pageTitle,
        page_location: window.location.href
      });
    }
  }, [location]);

  return (
    <>
      <nav className="navbar navbar-expand navbar-grey bg-grey fixed-top">
        <div className="container">
          <Link to={"/"} className="navbar-brand replay-pro-logo">
            <img src='/images/replay-pro-logo.svg' alt="Replay Pro Logo" />
          </Link>
          <div className="ms-auto d-flex flex-column align-items-start">
            <Link to="/patrocinio" className="nav-link fw-bold py-0 text-danger text-hover-light">
              <i className="bi bi-clipboard-heart"></i> &nbsp;Patrocínio
            </Link>
            <Link to="/contato" className="nav-link fw-bold py-0 text-danger text-hover-light">
              <i className="bi bi-chat-left-text"></i> &nbsp;Fale com a gente!
            </Link>
          </div>
        </div>
      </nav>

      <div className="container">
        <Routes>
          <Route path="/" element={<ArenasList />} />
          <Route path="/arenas" element={<ArenasList />} />
          <Route path="/arenas/:id/:name" element={<Arena />} />
          <Route path="/arenas/:id/:name/:place" element={<Place />} />
          <Route path="/arenas/:id/:name/:place/:date" element={<Place />} />
          <Route path="/arenas/:id/:name/:place/:date/:hour" element={<Place />} />
          <Route path="/contato" element={<Contact />} />
          <Route path="/patrocinio" element={<Sponsorship />} />
        </Routes>
      </div>

      <footer className="pb-3 mt-5 footer">
        <div className="container pb-2">
          <Row className="align-items-start">
            <Col className="col-4 col-md-3 col-xl-2 col">
              <img src='/images/replay-pro-white.svg' width="100%" alt="Replay Pro Logo" />
            </Col>
            <Col className="col-0 d-none d-md-block col-md-2 col-xl-3 col"></Col>
            <Col className="col-8 col-md-7 col-xl-7 col">
              <div className="text-right">
                <span className="slogan-main">REVIVA A EMOÇÃO!</span>
                <span className="slogan-desc"> COMPARTILHE MOMENTOS INESQUECÍVEIS!</span>
              </div>
            </Col>
          </Row>
          <a
            href="https://incit.com.br/project/replaypro/"
            target="_blank"
            rel="noopener noreferrer"
            className="d-flex align-items-center justify-content-center mt-2 text-decoration-none hover-opacity"
          >
            <img
              src='/images/selo-incubada.png'
              alt="Selo Unifei"
              height="120"
              className="d-inline-block p-2"
            />
            <img
              src='/images/selo-hard-tech.png'
              alt="Selo Unifei"
              height="120"
              className="d-inline-block p-2"
            />
            <span className="text-light p-2" style={{ fontSize: '1rem' }}>
              Startup Incubada: Incit
            </span>
          </a>
        </div>
        <div className="text-center pt-2">©{new Date().getFullYear()} Replay Pro. Todos os direitos reservados.</div>
      </footer>
    </>
  );
};

export default App;